import { ofType } from 'redux-observable';
import { combineLatest, type Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import type { Action } from 'state/actions';

export function getTabRemoved$(actions$: Observable<Action>, tabId: string) {
  return actions$.pipe(
    ofType('SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB', 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB'),
    filter(t => t.tabId === tabId),
  );
}

export function waitUntilConnectedToSignalR<T>(input$: Observable<T>, action$: Observable<Action>): Observable<T> {
  const connected$ = action$.pipe(ofType('SIGNALR_CONNECTION_SUCCEED'));
  return combineLatest([input$, connected$]).pipe(map(([input, _]) => input));
}
